import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmailDomainPolicyDto } from '../interfaces/email-domain-policy-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class EmailDomainPolicyService {
    private readonly http = inject(HttpClient);
    private env = inject(envToken);


    getEmailDomainPolicyUrl = '';
    saveEmailDomainPolicyUrl = '';

    constructor() {
        this.getEmailDomainPolicyUrl = this.env.apiUrl + '/api/v1/email-domain-policy/enterprise/';
        this.saveEmailDomainPolicyUrl = this.env.apiUrl + '/api/v1/policy/email-domain/enterprise/';
    }

    getEmailDomainPolicy(enterpriseId: number): Observable<EmailDomainPolicyDto> {
        return this.http.get<EmailDomainPolicyDto>(`${this.getEmailDomainPolicyUrl}${enterpriseId}`);
    }

    saveEmailDomainPolicy(enterpriseId: number, emailDomainPolicy: EmailDomainPolicyDto) {
        return this.http.post(`${this.saveEmailDomainPolicyUrl}${enterpriseId}`, emailDomainPolicy);
    }

}
